export const galleryCommonImgixProps = {
  ar: '3:2',
  crop: 'center',
  trim: 'color',
  fill: 'solid',
  fillColor: 'F5F6F8',
  fit: 'fill',
  trimColor: 'F5F6F8',
  trimPad: 50,
  trimTol: 50,
};

export const GALLERY_IMAGE_WIDTH = 1000;
export const GALLERY_IMAGE_WIDTH_ZOOM = 2100;
